import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import lodash from 'lodash'
import { Button, Col, Form, Input, Modal, notification, Row } from "antd"
import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { AdminAppApi } from "../../Api/AdminAppApi"
import { CREATE_SENDER_ERROR } from "../../Util/Constants"
const { Item } = Form

export interface Props {
	onVisibleChange: (visible: boolean) => void
	onSuccess: () => void
}

const ModalAppCreateSender: React.FC<Props> = (props: Props) => {
	const [form] = Form.useForm()
	const { appCode } = useParams()
	const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true)

	const footerCustom = [
		<Button
			className="btn cancel"
			key="cancel"
			htmlType="button"
			icon={<CloseOutlined />}
			onClick={() => props.onVisibleChange(false)}
		>
			Hủy Bỏ
		</Button>,
		<Button
			key="ok"
			form="form_edit"
			className="btn"
			htmlType="submit"
			disabled={submitButtonDisabled}
			icon={<CheckOutlined />}
		>
			Xác nhận
		</Button>,
	]

	const handleFinish = () => {
		form.validateFields()
			.then((values) => {
				return AdminAppApi.addSender(appCode!, values)
			})
			.then(() => {
				props.onSuccess()
				props.onVisibleChange(false)
				notification.success({
					message: "Thêm người gửi thành công.",
				})
			})
			.catch((err) => {
				const title = lodash.get(err.response, 'data.title').toUpperCase()
				notification.error({ message: CREATE_SENDER_ERROR[title] || "Đã xảy ra lỗi !" })
			})
	}

	const onFieldsChangeHandle = () => {
		setSubmitButtonDisabled(form.getFieldsError().some((field) => field.errors.length > 0))
	}

	return (
		<Modal
			title="Thêm người gửi"
			visible={true}
			centered
			onCancel={() => props.onVisibleChange(false)}
			width={700}
			okText="Xác nhận"
			cancelText="Huỷ bỏ"
			closable={true}
			footer={footerCustom}
			className="app-modal"
		>
			<Row align="middle" gutter={[16, 24]} className="app-modal-edit">
				<Col xs={24}>
					<Form form={form} onFinish={handleFinish} name="form_edit" onFieldsChange={onFieldsChangeHandle}>
						<Item
							label={<span className="need-required mg-r-22">Nhập E-mail:</span>}
							name="email"
							rules={[
								{
									required: true,
									message: "Vui lòng nhập email...",
								},
								{
									type: "regexp",
									pattern: new RegExp(/^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/),
									message: "Email không hợp lệ...",
								},
								{
									type: "email",
									message: "Email không hợp lệ...",
								},
							]}
						>
							<Input autoFocus={true} placeholder="E-mail..." />
						</Item>
					</Form>
				</Col>
			</Row>
		</Modal>
	)
}

export default ModalAppCreateSender
